import Image from "next/image";

interface HeroFallbackProps {
  /**
   * If true, renders with preload (used for the LCP path on mobile and
   * prefers-reduced-motion). If false, renders without preload (used as the
   * placeholder behind the desktop WebGL canvas while it loads).
   */
  preload?: boolean;
}

export function HeroFallback({ preload = false }: HeroFallbackProps) {
  return (
    <div className="relative aspect-square h-full w-full">
      <Image
        src="/images/traderoyale-crown.png"
        alt="Trade Royale crown"
        fill
        sizes="(max-width: 640px) 280px, (max-width: 1024px) 360px, 520px"
        quality={90}
        preload={preload}
        className="object-contain drop-shadow-[0_0_60px_rgba(207,174,96,0.35)]"
      />
    </div>
  );
}
